import InfoIcon from '@mui/icons-material/Info';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FC, useId } from 'react';

type Props = {
  isOpen: boolean;
  close: () => void;
  title?: string | undefined;
  message?: string | undefined;
};

export const ClientNotificationDialog: FC<Props> = (props) => {
  const { isOpen, close, title, message } = props;

  const titleId = useId();
  const descriptionId = useId();
  const CLIENT_NOTIFICATION_DIALOG_WIDTH = '512px';

  return (
    <Dialog
      open={isOpen}
      onClose={() => close()}
      aria-labelledby={titleId}
      aria-describedby={descriptionId}
      fullWidth
      maxWidth={false}
      sx={{
        '& .MuiDialog-paper': {
          width: CLIENT_NOTIFICATION_DIALOG_WIDTH,
          maxWidth: CLIENT_NOTIFICATION_DIALOG_WIDTH,
        },
      }}
    >
      <DialogTitle id={titleId}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <InfoIcon
            sx={{
              color: 'info.main',
              fontSize: '20px',
              mr: 1,
            }}
          />
          {title}
        </Box>
      </DialogTitle>
      <DialogContent>
        {message && (
          <DialogContentText
            id={descriptionId}
            sx={{
              whiteSpace: 'pre-line',
              wordBreak: 'break-word',
              color: 'text.primary',
            }}
          >
            {message}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close()} autoFocus>
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};
